<template>
  <div class="page-container login-page">
    <div class="login-content">
      <div class="logo-section">
        <img
          :src="logoUrl"
          alt="Logo"
          class="logo-img"
        />
        <h1 class="app-title">兑换中心</h1>
        <p class="app-subtitle">用户物品兑换系统</p>
      </div>

      <div class="form-section">
        <div class="input-group">
          <i class="el-icon-mobile-phone input-icon"></i>
          <input
            v-model="phone"
            type="tel"
            maxlength="11"
            placeholder="请输入手机号"
            class="form-input"
            @input="validatePhone"
          />
        </div>

        <div class="input-group code-group">
          <i class="el-icon-message input-icon"></i>
          <input
            v-model="code"
            type="text"
            maxlength="6"
            placeholder="请输入验证码"
            class="form-input code-input"
            @input="validateCode"
          />
          <button
            :disabled="countdown > 0 || !isPhoneValid"
            class="code-btn"
            :class="{ disabled: countdown > 0 || !isPhoneValid }"
            @click="sendCode"
          >
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>

        <button
          :disabled="!canLogin"
          class="btn-primary login-btn"
          :class="{ 'btn-disabled': !canLogin }"
          @click="handleLogin"
        >
          登 录
        </button>
      </div>

      <div class="tips-section">
        <p class="tip-text">登录即表示同意《用户服务协议》</p>
        <button
          v-if="servicePhone"
          class="contact-service-btn"
          @click="showServiceDialog = true"
        >
          <i class="el-icon-phone-outline"></i> 联系客服
        </button>
      </div>

      <!-- 客服电话弹窗 -->
      <div
        v-if="showServiceDialog"
        class="service-dialog-overlay"
        @click.self="showServiceDialog = false"
      >
        <div class="service-dialog">
          <div class="dialog-header">
            <span class="dialog-title">联系客服</span>
            <button class="dialog-close" @click="showServiceDialog = false">&times;</button>
          </div>
          <div class="dialog-body">
            <p class="dialog-hint">如有问题，请拨打以下电话联系我们</p>
            <a :href="'tel:' + servicePhone" class="phone-number">{{ servicePhone }}</a>
            <p class="dialog-tip">点击号码即可拨打电话</p>
          </div>
          <div class="dialog-footer">
            <button class="btn-dialog-cancel" @click="showServiceDialog = false">取消</button>
            <a :href="'tel:' + servicePhone" class="btn-dialog-call">
              <i class="el-icon-phone"></i> 立即拨打
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendSmsCode, smsLogin } from '../api/user'
import { getConfig } from '../api/config'
import { setToken } from '../utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      code: '',
      countdown: 0,
      timer: null,
      isPhoneValid: false,
      isCodeValid: false,
      logoUrl: '',
      servicePhone: '',
      showServiceDialog: false
    }
  },
  computed: {
    canLogin() {
      return this.isPhoneValid && this.isCodeValid && this.code.length === 6
    }
  },
  methods: {
    async fetchLogo() {
      try {
        const res = await getConfig()
        if (res.data) {
          if (res.data.client_logo) {
            this.logoUrl = res.data.client_logo
          } else {
            this.logoUrl = 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Minimalist%20logo%20placeholder%20200x200&image_size=square'
          }
          if (res.data.service_phone) {
            this.servicePhone = res.data.service_phone
          }
        } else {
          this.logoUrl = 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Minimalist%20logo%20placeholder%20200x200&image_size=square'
        }
      } catch (error) {
        this.logoUrl = 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Minimalist%20logo%20placeholder%20200x200&image_size=square'
      }
    },
    validatePhone() {
      const phoneReg = /^1[3-9]\d{9}$/
      this.isPhoneValid = phoneReg.test(this.phone)
    },
    validateCode() {
      const codeReg = /^\d{0,6}$/
      if (codeReg.test(this.code)) {
        this.code = this.code
      } else {
        this.code = this.code.replace(/[^\d]/g, '')
      }
      this.isCodeValid = this.code.length === 6
    },
    async sendCode() {
      if (this.countdown > 0 || !this.isPhoneValid) return

      try {
        const res = await sendSmsCode({ phone: this.phone })

        this.countdown = 60
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)

        this.$message({
          message: res.msg || '验证码发送成功',
          type: 'success',
          duration: 3000,
          customClass: 'login-tip-message'
        })
      } catch (error) {
        console.error('发送验证码失败:', error)
      }
    },
    async handleLogin() {
      if (!this.canLogin) return

      const loading = this.$loading({
        lock: true,
        text: '登录中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })

      try {
        const res = await smsLogin({
          phone: this.phone,
          code: this.code
        })

        if (res.data && res.data.token) {
          setToken(res.data.token)

          if (res.data.userinfo) {
            localStorage.setItem('mcexchange_userinfo', JSON.stringify(res.data.userinfo))
          }

          loading.close()
          this.$message.success(res.msg || '登录成功')
          this.$router.push('/orders')
        } else {
          loading.close()
          this.$message.error(res.msg || '登录失败：未获取到token')
        }
      } catch (error) {
        loading.close()
        console.error('登录失败:', error)
        this.$message.error(error.msg || error.message || '登录失败')
      }
    }
  },
  created() {
    this.fetchLogo()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.login-page {
  background: linear-gradient(180deg, #409eff, #7bb8f5);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-content {
  width: 100%;
  padding: 60px 24px 40px;
  max-width: 400px;
}

.logo-section {
  text-align: center;
  margin-bottom: 48px;
  animation: fadeInDown 0.8s ease-out;
}

.logo-img {
  width: 200px;
  height: 200px;
  border-radius: 24px;
  margin-bottom: 20px;
  box-shadow: 0 8px 32px rgba(64, 158, 255, 0.25);
  object-fit: cover;
}

.app-title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
  letter-spacing: 2px;
}

.app-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
}

.form-section {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.input-group {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.input-group:focus-within {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.input-icon {
  font-size: 18px;
  color: #909399;
  margin-left: 14px;
  width: 24px;
  text-align: center;
}

.form-input {
  flex: 1;
  height: 48px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: transparent;
  border: none;
}

.form-input::placeholder {
  color: #c0c4cc;
}

.code-group {
  position: relative;
}

.code-input {
  padding-right: 120px;
}

.code-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  padding: 8px 16px;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  border: none;
  min-width: 108px;
}

.code-btn:not(.disabled):active {
  transform: translateY(-50%) scale(0.95);
}

.code-btn.disabled {
  background: #dcdfe6;
  color: #fff;
  cursor: not-allowed;
}

.login-btn {
  width: 100%;
  margin-top: 28px;
  height: 50px;
  font-size: 17px;
  letter-spacing: 4px;
}

.btn-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tips-section {
  text-align: center;
  margin-top: 24px;
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

.tip-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.contact-service-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-service-btn:active {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(0.96);
}

/* 客服弹窗 */
.service-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

.service-dialog {
  width: 280px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  animation: dialogIn 0.3s ease-out;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.dialog-close {
  width: 28px;
  height: 28px;
  border: none;
  background: #f5f7fa;
  border-radius: 50%;
  font-size: 18px;
  color: #909399;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-body {
  padding: 24px 18px;
  text-align: center;
}

.dialog-hint {
  font-size: 14px;
  color: #909399;
  margin-bottom: 16px;
}

.phone-number {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #409EFF;
  text-decoration: none;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.phone-number:active {
  opacity: 0.7;
}

.dialog-tip {
  font-size: 12px;
  color: #c0c4cc;
}

.dialog-footer {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

.btn-dialog-cancel,
.btn-dialog-call {
  flex: 1;
  padding: 14px 0;
  text-align: center;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.btn-dialog-cancel {
  background: #fff;
  color: #909399;
  border-right: 1px solid #f0f0f0;
}

.btn-dialog-cancel:active {
  background: #f5f7fa;
}

.btn-dialog-call {
  background: #fff;
  color: #409EFF;
  font-weight: 600;
}

.btn-dialog-call:active {
  background: #ecf5ff;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes dialogIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>